<div class="toggle"><q-toggle v-model="value" size="60px"></q-toggle><div class="cover" v-if="synapse.editable"></div></div>